import { useQuery } from '@tanstack/react-query';

import { lookupStatesController } from '@/interface-adapters/controllers/lookups/get-states.controller';

export const useStatesQuery = () => {
	return useQuery({
		queryKey: ['STATES'],
		queryFn: () => lookupStatesController()
	});
};
